import PortableText from "components/PortableText"
import { urlForImage } from "lib/sanity.image"
import { VerticalCards2Item } from "schemas"
import { styled } from "styled-system/jsx"

type Props = VerticalCards2Item

function VerticalCards2Item({ title, content, image }: Props) {
  return (
    <styled.div
      css={{
        maxWidth: "400px",
        p: 4,
        bg: "white",
        rounded: "40px",
        color: "other.1",
        textAlign: "center",
        lineHeight: "150%",
      }}>
      {image?.asset && (
        <styled.img
          src={urlForImage(image).width(400).url()}
          alt={image.alt || ""}
        />
      )}

      <styled.div
        css={{
          py: { base: 6, lg: 8 },
        }}>
        <styled.h3
          css={{
            color: "#000A3A",
            fontFamily: "heading",
            fontSize: { base: "16px", lg: "20px" },
            fontWeight: "600",
            letterSpacing: "-0.38px",
            mb: { base: 3, lg: 4 },
          }}>
          {title}
        </styled.h3>

        <styled.div
          css={{
            color: "rgba(0, 10, 58, 0.80)",
            fontSize: { base: "12px", lg: "16px" },
            letterSpacing: "-0.304px",
          }}>
          <PortableText className={"x"} value={content} />
        </styled.div>
      </styled.div>
    </styled.div>
  )
}

export default VerticalCards2Item
export type { Props as VerticalCards2ItemProps }
